// RED live codes verified on dev October 12; the spaced email codes fail.
const redSkus: Record<string, string> = {
    FS2E: 'FR2E-V2',
    'FS2E-V2': 'FR2E-V2',
    'FS2E - V2': 'FR2E-V2',
    'FR2E - V2': 'FR2E-V2',
    FS3E: 'FR3E-V2',
    'FS3E-V2': 'FR3E-V2',
    'FS3E - V2': 'FR3E-V2',
    'FR3E - V2': 'FR3E-V2',
    FS4E: 'FR4E-V2',
    'FS4E-V2': 'FR4E-V2',
    'FS4E - V2': 'FR4E-V2',
    'FR4E - V2': 'FR4E-V2',
};

export const resolveEpigraphSku = (
    tourSku?: string,
    buttonSku?: string,
    slug?: string
): string | undefined => {
    const sku = tourSku || buttonSku;
    if (!sku || sku === 'E3E' || sku === 'E4E') return undefined;

    // Retired mPulse AR records must use the same identifier as the tour.
    const legacySku = ['P2E-red', 'P3E-red', 'P4E-red', 'P6E-red'].includes(sku)
        ? sku.slice(0, -4)
        : sku;

    if (
        slug?.split('/').includes('amplify-red-light-saunas') ||
        ['amplify-red-ii', 'amplify-red-iii', 'amplify-red-iv'].includes(
            slug || ''
        )
    ) {
        return redSkus[legacySku] || legacySku;
    }

    return legacySku;
};
